export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = ['About', 'Features', 'Pricing', 'Blog', 'Support'];

  return (
    <footer className="py-12 bg-white border-t border-gray-100" data-testid="footer">
      <div className="container-main text-center">
        {/* Tagline */}
        <p className="text-[#1E293B] font-semibold text-lg mb-6">
          BoardChat — Where Projects and Conversations Come Together.
        </p>

        {/* Links */}
        <div className="flex flex-wrap items-center justify-center gap-6 mb-8">
          {footerLinks.map((link) => (
            <a
              key={link}
              href="#"
              className="text-[#64748B] hover:text-[#2563EB] text-sm transition-colors"
            >
              {link}
            </a>
          ))}
        </div>

        {/* Copyright */}
        <p className="text-[#94A3B8] text-sm">
          © {currentYear} BoardChat. All rights reserved.
        </p>
      </div>
    </footer>
  );
};
